import { GetterTree } from "vuex";
import * as types from "../constants/ins_user_info_types";
import { InsUserInfo } from "../modules/ins_user_info_module";
import ShowInsVerify from "@/utils/show_ins_verify";
const Getters: GetterTree<any, any> = {
  [types.GETTER_CURRENT_INS_USER_INFO](state, getters, rootState) {
    return state.ins_user_info_list.find((user: InsUserInfo) => {
      return user.user_id === rootState.index_module.current_user_id;
    });
  },
  [types.GETTER_INS_USER_INFO_LIST](state) {
    return state.ins_user_info_list;
  },
  [types.GETTER_LOGIN_INS_USER_LIST](state) {
    return state.ins_user_info_list.filter(
      (item: InsUserInfo) => item.user_type === "login"
    );
  },
  [types.GETTER_INS_USER_INFO_BY_ID](state) {
    return (payload: string) =>
      state.ins_user_info_list.find(
        (item: InsUserInfo) => item.user_id === payload
      );
  },
  [types.GETTER_ONE_INS_LOGIN_USER_ID](state, getters) {
    const currentUserInfo = getters[types.GETTER_CURRENT_INS_USER_INFO];
    if (!currentUserInfo) {
      return null;
    } else if (currentUserInfo.user_type === "login") {
      return currentUserInfo.user_id;
    }
    const loginList = getters[types.GETTER_LOGIN_INS_USER_LIST];
    return loginList && loginList[0] && loginList[0].user_id;
  },
  [types.GETTER_NOT_VERFY_USER_ID](state, getters) {
    const loginList = getters[types.GETTER_LOGIN_INS_USER_LIST];
    for (const j of loginList) {
      const notVerify = !ShowInsVerify.findVerifyList(j.user_id);
      if (notVerify) {
        return j.user_id;
      }
    }
  },
  [types.GETTER_API_LOGIN_USER_ID](state, getters) {
    return (user_id: string) => {
      if (user_id) {
        const findUserInfo = getters[types.GETTER_INS_USER_INFO_BY_ID](user_id);
        if (findUserInfo.user_type === "login") {
          // 当前账号是登录，就用当前登录的userid
          return findUserInfo.user_id;
        }
      }
      // 当前账号veirfy了，就找一个没有veriy的
      const notVerifyId = getters[types.GETTER_NOT_VERFY_USER_ID];
      if (notVerifyId) {
        return notVerifyId;
      }
      // 找不到，返回一个登录账号的user_id
      return getters[types.GETTER_ONE_INS_LOGIN_USER_ID];
    };
  }
};
export default Getters;
